import * as aor from "react-admin";
import React, { Component } from "react";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

class PasswordField extends Component {
    state = {
        showPassword: false
    };

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };

    render() {
        const { label, source, record } = this.props;
        return (source === "admin_password" && record.pwd_admin_enabled) ||
            (source === "admin_l2_password" && record.pwd_adminl2_enabled) ? (
            <aor.Labeled label={label}>
                <Input
                    style={{ color: "black" }}
                    id={source}
                    type={this.state.showPassword ? "text" : "password"}
                    value={record[source]}
                    disabled={true}
                    endAdornment={
                        <InputAdornment>
                            <IconButton
                                aria-label="Toggle password visibility"
                                onClick={this.handleClickShowPassword}
                                onMouseDown={this.handleMouseDownPassword}
                            >
                                {this.state.showPassword ? (
                                    <VisibilityOff />
                                ) : (
                                    <Visibility />
                                )}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </aor.Labeled>
        ) : null;
    }
}

export default PasswordField;



// WEBPACK FOOTER //
// ./src/components/PasswordField.js